var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCard',{attrs:{"flat":""}},[_c('BaseCardBody',[_c('h3',{staticClass:"text-sm"},[_vm._v("Facebook: "+_vm._s(_vm.type))]),_c('h5',{staticClass:"text-xs font-normal text-gray-500"},[_vm._v("Subtype: "+_vm._s(_vm.subType))]),_c('p',{staticClass:"text-xs text-gray-500 mt-1"},[_vm._v("Account: "+_vm._s(_vm.account))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }